<div class="neptune-modal-cover">
    <div
      id="photo-gallery"
      class="flex flex-col min-w-200 w-256 h-150 bg-white p-8 gap-4 overflow-auto box-border"
    >
      <section
        id="gallery-header"
        class="flex justify-between items-center pb-2 shrink-0 neptune-border-b-1 border-sky-blue"
      >
        <span id="gallery-title" class="text-2xl">
          {{ serviceInsightsPhotoObject.shippingCity }},
          {{ serviceInsightsPhotoObject.shippingState }} |
          {{ serviceInsightsPhotoObject.accountName }}
        </span>

        <button
          id="gallery-close-button"
          class="neptune-button-white border-none"
          (click)="onIconCloseClicked()"
        >
          <img
            src="/assets/shared-icons/neptune-icon-blue-close.svg"
            alt="Close Icon"
          />
        </button>
      </section>

      <section
        id="gallery-body"
        class="flex flex-col flex-1 overflow-hidden gap-4 min-h-0"
      >
        <!-- Fixed toolbar -->
        <section
          id="gallery-selection-toolbar"
          class="shrink-0 flex justify-between items-center text-sm"
        >
          <span class="photo-count text-neptune-color-fg-muted">
            {{ serviceInsightsPhotoObject.photoInfo.length }} Photos
          </span>

          <div id="gallery-select-all" class="flex gap-2 items-center">
            <input
              type="checkbox"
              id="selectAll"
              name="selectAll"
              class="accent-blue"
              (click)="onSelectAllClick($event)"
              [checked]="
                getSelectedPhotosCount() ===
                serviceInsightsPhotoObject.photoInfo.length
              "
            />
            <label for="selectAll">Select All</label>
          </div>
        </section>

        <!-- Scrollable content -->
        <div class="flex-1 overflow-y-auto min-h-0 flex flex-col gap-4">
          <section id="gallery-featured-photo">
            <service-insights-photo-carousel
              [serviceInsightsPhotoObject]="serviceInsightsPhotoObject"
              [currentSlideIndex]="currentPhotoIndex"
              (photoSelected)="currentPhotoIndex = $event"
            >
            </service-insights-photo-carousel>
          </section>

          <section
            id="gallery-thumbnails"
            class="flex flex-wrap gap-6 content-start"
          >
            <div
              *ngFor="
                let photo of serviceInsightsPhotoObject.photoInfo.slice(
                  currentSlideIndex,
                  currentSlideIndex + photosPerPage
                )
              "
            >
              <service-insights-photo-gallery-item
                class="photo-view-card"
                [photo]="photo"
                [photoObject]="serviceInsightsPhotoObject"
                (selectClick)="handleSelectClick($event, photo.id)"
                (photoClick)="onPhotoClick(photo.id)"
                [componentId]="'multi-photo-gallery'"
                [isInFocus]="currentPhotoIndex === photo.id"
              ></service-insights-photo-gallery-item>
            </div>
          </section>
        </div>
      </section>

      <section
        id="gallery-footer"
        class="flex justify-between items-center shrink-0"
      >
        <div id="gallery-selection-count">
          {{ getSelectedPhotosCount() }}
          {{ getSelectedPhotosCount() > 1 ? "Photos" : "Photo" }} Selected
        </div>

        <section id="gallery-actions" class="flex gap-4">
          <button
            id="gallery-reset-button"
            class="neptune-button-white"
            (click)="resetSelection()"
          >
            <img
              src="/assets/shared-icons/neptune-icon-blue-refresh.svg"
              alt="Reset Icon"
            />
            Reset
          </button>
          <button
            id="gallery-download-button"
            [ngClass]="
              getSelectedPhotosCount() === 0
                ? 'neptune-button-disabled'
                : 'neptune-button-blue'
            "
            (click)="downloadImagesAsZip()"
          >
            <img
              src="/assets/shared-icons/neptune-download-icon.svg"
              alt="Download Icon"
            />Download
          </button>
        </section>
      </section>
    </div>
  </div>

